export const GANDALF_API_HOST = process.env.NEXT_PUBLIC_GANDALF_API_HOST || "";
export const DINEOUT_CART_API_HOST = process.env.NEXT_PUBLIC_DINEOUT_CART_API_HOST || "";
export const CHECKOUT_WEB_APP_URL = process.env.NEXT_PUBLIC_CHECKOUT_WEB_APP_URL || "";
export const DINEOUT_PARTNER_API_HOST = process.env.NEXT_PUBLIC_DINEOUT_PARTNER_API_HOST || "";

export const SUCCESS_STATUS_CODE = 0;
export const FAILURE_STATUS_CODE = 1;
// Backend signals "PIN generation skipped, verify existing PIN" with this status on create-order / track-page.
export const PIN_VERIFICATION_REQUIRED_STATUS_CODE = 155;

export const API_ENDPOINTS = {
    EXTERNAL_PLACE_ORDER: "/api/v1/checkout/placePGOrder",
    EXTERNAL_CONFIRM_ORDER: "/api/v1/checkout/confirm/order",
    GET_RESTAURANT_CONFIG: "/api/dinersone/useronboarding/json",
    UPDATE_CART: "/api/v1/json/checkout/cart/update",
    UPDATE_CART_DINEOUT: "/api/v2/view/digitalMenu/updateCart",
    GENERATE_PIN: "/api/v2/view/pin",
    VERIFY_PIN: "/api/v2/view/verify-pin",
    TRACK_ORDER: "/api/v2/dineout/digital-menu/create-order",
    TRACK_PAGE: "/api/v2/dineout/digital-menu/track-page",
    // Legacy (backup) endpoints on GANDALF_API_HOST — used when the matching useDineoutCartHost* flag is false.
    TRACK_PAGE_OLD: "/api/v2/json/track/card",
    CREATE_ORDER_OLD: "/api/v2/json/track/card",
    MENU_PL_API: "/api/v1/entity/ENTITY_DINEOUT_MENU/{0}/json?restaurantId={1}&tableId={2}&consentLDA={3}",
    GET_BILL: "/api/v2/view/getBill",
    GET_PAY_BILL_CONFIGS: "/api/v2/view/getPayBillConfigs",
    QUICK_ACTIONS: "/api/v1/quickActions/submit",
    COLLECTIONS_PL_API: "/api/v1/dineout_item_collection/json/{0}",
    GET_PAYMENT_OPTIONS: "/api/v2/view/digitalMenu/payment/cards",
    DIGITAL_MENU_CONFIG: "/api/v1/digital-menu/config/json",
    DIGITAL_MENU_QR_SCAN: "/api/v1/digital-menu/qr-scan",
    CROSS_SELL_PL_API: "/api/v1/json/layout-section/CROSS_SELL_DINEOUT",
};

export const LOG_TABLES = {
    LOG: "api_log",
    ERROR: "api_error",
};

export const STATIC_HEADERS = {
    callerId: "Portal",
};

export const NR_TABLES = {
    STATIC_PAGE_PL_WIDGET_ERROR: "static_page_pl_widget_error",
    STATIC_PAGE_PL_WIDGET_INVALID: "static_page_pl_widget_invalid",
    STATIC_PAGE_PL_WIDGET_EMPTY: "static_page_pl_widget_empty",
    PORTAL_DINEOUT_SCRIPT_LOAD_ERROR: "portal_dineout_script_load_error",
    NATIVE_BRIDGE_FETCH_CART_ERROR: "native_bridge_fetch_cart_error",
    SESSION_STORAGE_FETCH_CART_ERROR: "session_storage_fetch_cart_error",
    SESSION_STORAGE_TABLE_CONFIG_ERROR: "session_storage_table_config_error",
    CONFIG_FETCH_DMV2_API_ERROR: "config_fetch_dmv2_api_error",
    CROSS_SELL_CONFIG_FETCH_ERROR: "cross_sell_config_fetch_error",
    QR_SCAN_API_ERROR: "qr_scan_api_error",
    PIN_VERIFY_FAILURE: "portal_dineout_error_pin_verify_failure",
};

export const NATIVE_BRIDGE_TIMEOUT_MS = 2000;
export const NB_DOWNLOAD_FILE_TIMEOUT_MS = 5000;
